<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding: 3px;
    }
</style>

<template>
	<div class="vx-col w-full mb-base">
		<vs-card title="Inbound Details" class="p-4 mb-6">
         <div slot="header" class="flex flex-wrap items-center justify-between">
            <div class="flex items-center">
                <vs-button radius color="primary" icon="keyboard_backspace" @click="cancelAndBack()"></vs-button>
                <h4 class="ml-3">View</h4>
            </div>
            <div class="flex items-center" >
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="on_edit = true" v-show="!on_edit && inbound_status.id < 3" icon="edit">Edit</vs-button>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="updateInbound" v-show="on_edit " icon="save">Update</vs-button>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="exportFile" v-show="!on_edit" icon="print">Print</vs-button>
            </div>
        </div>
		<div class="vx-row mt-6">
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound ID*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_id" disabled/>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound Reference*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_reference" :disabled="!on_edit || inbound_status.id > 1" />
					</div>
				</div>
				<div class="vx-row mb-3 mt-1">
					<div class="vx-col w-1/3">
						Arrival Date*
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" v-model="arrival_date" :disabled="!on_edit || inbound_status.id > 1" />
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Supplier ID*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="supplier_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, supplier)"
                            @change="setSelected"
                            :disabled="!on_edit || inbound_status.id > 1"
                        >
                            <vs-select-item v-for="(item, index) in supplier.data" :key="index" :value="item.id" :text="item.name"/>
                        </vs-select>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						&nbsp;
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="supplier_address_1" disabled />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						&nbsp;
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="supplier_address_2" disabled />
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Client ID*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="client_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, client)"
                            :disabled="!on_edit || inbound_status.id > 1 || inboundItems.length > 0"
                        >
                            <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                        </vs-select>
                    </div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Order Type*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="order_type_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, order_type)"
                            :disabled="!on_edit || inbound_status.id > 1"
                        >
                            <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                        </vs-select>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Warehouse*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="warehouse_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, warehouse)"
                            :disabled="!on_edit || inbound_status.id > 1"
                        >
                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                        </vs-select>
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound Status
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_status.name" disabled />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						PO Date
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" label="PO Date" v-model="po_date" :disabled="!on_edit || inbound_status.id > 1" />
					</div>
				</div>
			</div>
		</div>
		<vs-tabs class="mt-10">
			<vs-tab label="Item Details">
				<vs-button @click="addItem()" class="btn mr-1 mt-5" :disabled="client_id == null || !on_edit " type="border">Add</vs-button>
				<vs-button @click="removeItem()" class="btn mr-1 mt-5" :disabled="selected.length < 1 || !on_edit " type="border">Remove</vs-button>
                <vs-table v-model="selected" :data="inboundItems" hoverFlat class="mt-5" multiple pagination max-items="20">
                    <template slot="thead">
                        <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                        <vs-th style="min-width: 200px;">Product ID</vs-th>
                        <vs-th style="min-width: 200px;">Description</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Open Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Recv Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-show="tr.status != 'delete' ">
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.line_id" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.product_id"
                                    width="100%"
                                    @input="setSelectedProduct(tr)" 
                                    @input-change="searchProductClient($event)"
                                    autocomplete
                                    :disabled="!on_edit || disabledFullyRecv(tr) || tr.recv_qty > 0"
                                >
                                <vs-select-item v-for="(item, index) in productOption" :key="index" :value="item.id" :text="item.product_code"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.pack_id" :disabled="!on_edit || disabledFullyRecv(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.batch" :disabled="!on_edit || disabledFullyRecv(tr)"/>
                            </vs-td>
                            <vs-td>
                                <flat-pickr class="w-full" v-model="tr.expired_date" :disabled="!on_edit || disabledFullyRecv(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-input :danger="tr.err" val-icon-danger="clear" class="w-full" v-model="tr.qty" :disabled="tr.product_id.id == '' || !on_edit || disabledFullyRecv(tr)" @input="Conversion(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.uom_id.id"
                                    width="100%"
                                    autocomplete
                                    :disabled="tr.qty <= 0 || !on_edit || disabledFullyRecv(tr)"
                                    @change="Conversion(tr)"
                                    @input="onChangeUom(tr)"
                                >
                                <vs-select-item v-for="(item, index) in tr.uomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.open_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.recv_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.base_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.base_uom_id.id"
                                    width="100%"
                                    autocomplete
                                    :disabled="true"
                                >
                                <vs-select-item v-for="(item, index) in tr.baseUomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
			</vs-tab>
			<vs-tab label="Custom">
				<div class="vx-row mt-6">
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								AJU Number
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="aju_number"  :disabled="!on_edit"/>
							</div>
						</div>
						<div class="vx-row mb-3 mt-1">
							<div class="vx-col w-1/3">
								SPPB Number
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="sppb_number"  :disabled="!on_edit"/>  
							</div>
						</div>
						<div class="vx-row mb-3 mt-1">
							<div class="vx-col w-1/3">
								SPPB Date
							</div>
							<div class="vx-col w-2/3">
								<flat-pickr class="w-full" v-model="sppb_date"  :disabled="!on_edit"/>
							</div>
						</div>
						<div class="vx-row mb-3 mt-5">
							<div class="vx-col w-1/3">
								BL/AWB
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="blorawb"  :disabled="!on_edit"/>
							</div>
						</div>
					</div>
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Registration Number
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="registration_number" :disabled="!on_edit"/>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Registration Date
							</div>
							<div class="vx-col w-2/3">
								<flat-pickr class="w-full" v-model="registration_date"  :disabled="!on_edit"/>
							</div>
						</div>
						<div class="vx-row mb-3 mt-1">
							<div class="vx-col w-1/3">
								Invoice Number
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="invoice_number"  :disabled="!on_edit"/>
							</div>
						</div>
					</div>
				</div>
			</vs-tab>
			<vs-tab label="Notes">
				<vs-textarea height="200" class="mt-5" label="Notes" v-model="remark" :disabled="!on_edit"/>
			</vs-tab>
			<vs-tab label="Attachment"></vs-tab>
		</vs-tabs>
		</vs-card>
	</div>
</template>

<script type="text/javascript">
	import vSelect from 'vue-select'
	import { AgGridVue } from "ag-grid-vue"
	import InboundItem from '@/components/InboundItem.vue'
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	import '@/assets/scss/vuesax/_wmsTheme.scss';

    export default {
        name:"inb-create",
        components:{
            vSelect,
            flatPickr,
            InboundItem,
            AgGridVue,
        },
        data(){
            return {
                selected: [],
                disableClient: false,
                    data_conv:0,
                    isLoading:false,
                    inbound_id:'',
                    inbound_reference:'',
                    arrival_date:'',
                    saveState:false,
                    on_edit:false,
                    // supplier:
                    // {
                    // 	// id:{
                    // 		id:'',
                    // 		label:'', 
                    // 	// }, 
                    // },
                    supplier_id:'',
                    supplier_address_1:'',
                    supplier_address_2:'',
                    inbound_status:{},
                    client_id:null,
                    order_type_id:'',
                    warehouse_id:'',
                    po_date:'',
                    remark:'',

                    data:{
                            line_id:'',
                            product_id:'',
                            descriptions:'',
                            pack_id:'',
                            batch:'',
                            expired_date:'',
                            uom_id:'',
                            qty:'',
                            base_uom_id:'',
                            base_qty:'',
                            open_qty:'',
                            recv_qty:'',
                    },

                    // custom
                    custom_id:'',
                    aju_number:'',
                    sppb_number:'',
                    sppb_date:'',
                    blorawb:'',
                    registration_number:'',
                    registration_date:'',
                    invoice_number:'',
                    // end-custom

                    input12:'',
                    select1:2,
                    options1:[
                        {text:'IT',value:0},
                        {text:'Blade Runner',value:2},
                        {text:'Thor Ragnarok',value:3},
                    ],
                    inboundItems:[],
                    dataItemList:[],
                    detailLength:0,
                    clientDDL: null, 
                    clientOption: this.$store.state.user.userconfig.client_options,
                    warehouseDDL: null, 
                    warehouseOption: this.$store.state.user.userconfig.warehouse_options,
                    orderTypeDDL: null, 
                    orderTypeOption: [],
                    supplierDDL: {}, 
                    supplierOption: [],

                    // Table-config
                    gridOptions: {},
                    maxPageNumbers: 7,
                    gridApi: null,
                    clients: [],
                    columnDefs: null,
                    defaultColDef: {
                        sortable: true,
                        editable: true,
                        resizable: true,
                        suppressMenu: true
                    },
                    productOption:[], 
                    supplier: {
                        data: [],
                        loading: false,
                        endpoint: 'master/customers',
                        objectKey: 'name'
                    },
                    client: {
                        data: [],
                        loading: false,
                        endpoint: 'master/clients',
                        objectKey: 'client_code'
                    },
                    order_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/ordertypes',
                        objectKey: 'order_type'
                    },
                    warehouse: {
                        data: [],
                        loading: false,
                        endpoint: 'master/warehouses',
                        objectKey: 'warehouses_code'
                    }
            }
        },
    watch:{
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    beforeMount() {
        if(this.isLoading){
            this.$vs.loading()
        }
    },	
	methods:{
        exportFile(){
            this.$http.get('inbound/inbounddelivery/report/printpdf/'+this.inbound_id, { responseType: 'blob'})
            .then(response => {
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
        },
        disabledFullyRecv(data){
            if(data.old_recv_qty != 0 && data.old_open_qty == 0 && data.old_recv_qty == data.base_qty && this.inbound_status.id > 1){
                return true;
            }else{
                return false;
            }
        },
        cancelAndBack(){
            if(this.on_edit){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Leave Page`,
                    text: 'Changes you made may not be saved?',
                    accept: () => {
                            this.$router.go(-1);
                    }
                    })
            }else{
                this.$router.go(-1);
            }
        },
        searchProductClient(e) {
            this.$http.post('master/product/showbyclient', { client_id: this.client_id, product_code: e.target.value })
            .then(res => {
                res.data.data.map(item => {
                    if(this.productOption.findIndex(p => p.id === item.id) === -1) {
                        this.productOption.push(item)
                    }
                })
            })
        },
        setSelectedProduct(value) {
            if(value != null){
            this.$http.get('/master/product/'+value.product_id)
                .then((response) =>  {
                let prd = response.data; 
                    value.description = prd.product.description_1 != null ? prd.product.description_1 : '';
                    value.uomOption = [];
                    value.baseUomOption = [];
                    // for(let i = 0; i < prd.uoms.length; i++){
                    //     this.uomOption.push({...prd.uoms[i].uom, label:prd.uoms[i].uom.name,});
                    // }
                        // console.log("base_uom : "+JSON.stringify(prd.default_uom.uom.name)); 
                        // value.uomOption = prd.uoms;
                        prd.uoms.map(item => {
                            item.uom.numerator = item.numerator
                            item.uom.denominator = item.denominator
                            value.uomOption.push(item.uom);
                        })
                        // console.log(JSON.stringify(value.uomOption));
                        value.baseUomOption.push(prd.default_uom.uom);
                        value.uom_id = prd.default_uom.uom ;
                        value.base_uom_id = prd.default_uom.uom ;
                    this.onChangeUom(value);					  
                })
                .catch(function (error) {
                console.log(error);
                });
                
            }else{
                    this.uom_id = null;
                    this.uomOption = [];
                    this.base_uom_id = null;
                    this.baseUomOption = [];
                    this.descriptions = '';
            }
        },
        addItem(){
            this.isLoading = true
            let id = this.client_id ;
            function getProductbyClient(ax) {
                return ax.post('master/product/showbyclient', { client_id: id });
            }	
            this.$http.all([getProductbyClient(this.$http)])
            .then(this.$http.spread((products) => {
                products.data.data.map(item => {
                    if(this.productOption.findIndex(p => p.id === item.id) === -1) {
                        this.productOption.push(item)
                    }
                })

				this.inboundItems.push({
						id:0,
						line_id:this.generateLineId(),
						product_id:'',
						description:'',
						pack_id:'',
						batch:'',
						expired_date:'',
						uom_id:{
							id:'',
							name:''
						},
						qty:0,
						base_uom_id:{
							id:'',
							name:''
						},
						open_qty:0,
						recv_qty:0,
						base_qty:0,
						status:'insert',
						baseUomOption:[],
						uomOption:[],
						errText:'',
						err:false,
						denominator: 0,
						numerator: 0,
				});

                    this.isLoading = false
            }))

		},
		setSelected() {
            const index = this.supplier.data.findIndex(c => c.id == this.supplier_id)
            this.supplier_address_1 = this.supplier.data[index].address_1
            this.supplier_address_2 = this.supplier.data[index].address_2
        },
        onChangeUom(data){
            data.uomOption.map(uom => {
                if(uom.id == data.uom_id.id) {
                    data.denominator = uom.denominator
                    data.numerator = uom.numerator
                }
            })
        },
        onChangeClient(value){
            if(value == null){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Warning`,
                    text: 'Changing Client ID will be delete All Inbound Items',
                    accept: () => {
                        this.dataItemList= [];
                    }
                    })
            }
        },
        clicked(value){
            let ar = this.dataItemList;
            for(let i=0; i < ar.length; i++) {
                if(ar[i].item_id == value.item_id)
                {
                    ar.splice(i,1);
                }
            }
            this.dataItemList.push(value);
        },
        removeItem(index){
            let length = 0
            this.selected.map(item => {
                if(item.status !== 'delete') {
                    length++
                }
            })

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Warning`,
                text: `Are you sure want to delete ${length} line?`,
                accept: () => {
                    let indexes = []
                    this.selected.map(selected => {
                        this.inboundItems.map((detail, index) => {
                            if(selected.line_id == detail.line_id) {
                                indexes.push(index)
                            }
                        })
                    })

                    this.selected = []

                    indexes.sort((a, b) => b - a)
                    indexes.map(i => {
                        const item = this.inboundItems[i]
                        if(item.status === 'insert') {
                            this.inboundItems.splice(i, 1)
                        }
                        else {
                            this.inboundItems[i].status = 'delete';
                        }
                    })
                    this.updateLineId()
                }
            })
        },
        validationDetail(data){
            if(this.inbound_status.id > 1){
                    if(this.data_conv < data.recv_qty && data.recv_qty != 0){
                    data.errText = 'qty must be higer than recv qty';
                    data.err = true;
                    console.log('here 1');
                    }else if(this.data_conv >= data.old_recv_qty && data.old_recv_qty > 0){
                    let sisa = this.data_conv - data.old_recv_qty ;
                    data.open_qty = sisa ;
                    data.base_qty = this.data_conv;
                    data.errText = '';
                    data.err = false;
                    console.log('here 2');
                    }
                    else if(this.data_conv <= data.open_qty && data.recv_qty > 0){
                    data.errText = 'qty cant be lower than open qty';
                    data.err = true;
                    console.log('here 3');
                }
                else if(this.data_conv >= data.old_open_qty && data.old_open_qty > 0){
                    let sisa =  this.data_conv - data.old_recv_qty;
                    data.open_qty = sisa ;
                    data.base_qty = this.data_conv;
                    data.errText = '';
                    data.err = false;
                    console.log('here 4');
                    }else{
                    data.recv_qty = 0 ;
                    data.open_qty = this.data_conv ;
                    data.base_qty = this.data_conv;
                }

            }else{
                // data.qty = 0 ;
                data.open_qty = this.data_conv ;
                data.base_qty = this.data_conv;
                data.errText = '';
                data.err = false;
                console.log('here 4 : '+this.data_conv);
            }
        },
        Conversion : function(data){
            if(data.qty > 0){
                data.base_qty = (data.qty / data.denominator) * data.numerator
                data.open_qty = (data.qty / data.denominator) * data.numerator								
                data.err = false;
                data.errText = '';
            }else{
                data.open_qty = 0;
                data.base_qty = 0;
                data.err = true;
                data.errText = 'qty must be higer than 0';
            }
        },
        generateLineId(){
            let lineId = 1
            this.inboundItems.map(item => {
                if(item.status !== 'delete') {
                    lineId++
                }
            })

            return lineId
        },
        updateLineId(){
            let lineId = 1
            this.inboundItems.map(item => {
                if(item.status !== 'delete') {
                    item.line_id = lineId
                    lineId++
                }
            })
        },
        editInbound(){
                let id = this.client_id
            this.isLoading = true;
            function getProduct(ax) {
                return ax.post('master/product/showbyclient', { client_id: id });
            }	
            function getClient(ax) {
                return ax.post('/master/clients');
            }	         
            function getOrderTypes(ax) {
                return ax.post('/master/ordertypes');
            }  
            function getSuppliers(ax) {
                return ax.post('/master/customers');
            }          

            if( this.orderTypeOption.length == 0 
                && this.supplierOption.length == 0){
                this.$http.all([getProduct(this.$http), getOrderTypes(this.$http), getSuppliers(this.$http)])
                    .then(this.$http.spread((product, ordertypes, suppliers) => {

                    this.productOption = [];
                    this.orderTypeOption =  [];
                    this.supplierOption =  [];

                    this.productOption = product.data.data;
                    this.orderTypeOption =  ordertypes.data.data;
                    this.supplierOption =  suppliers.data.data;

                    this.isLoading = false;

                    }));
            }
            this.on_edit = true;
        },
        updateInbound(){

            if(this.inbound_reference == '' || !this.supplier_id || !this.client_id 
            || !this.order_type_id || !this.warehouse_id || this.req_del_date == '' ){

                this.$vs.notify({
                    color: 'danger',
                    title: 'Error Header ',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Please Check Data Inbound Detail'
                })
                return;
            }

            for(let detail of this.inboundItems){
                if(!detail.product_id || !detail.uom_id || detail.err ) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error Item Product',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Check Product Line ' + detail.line_id
                    })
                    return;
                }
            }

            this.isLoading = true ;
            let inbound_head = {
            id:this.inbound_id,
                inbound_reference:this.inbound_reference,
                supplier_id:this.supplier_id,
                client_id:this.client_id,
                order_type_id:this.order_type_id,
                warehouse_id:this.warehouse_id,
                po_date:this.po_date,
                req_del_date:this.arrival_date,
                remark:this.remark,
            };

            let inbound_detail_custom = {
                id:this.custom_id,
                aju_number:this.aju_number,
                sppb_number:this.sppb_number,
                sppb_date: this.sppb_date,
                blorawb:this.blorawb,
                registration_number:this.registration_number,
                registration_date:this.registration_date,
                invoice_number:this.invoice_number,
            };

            let data_details = [];

            this.inboundItems.map(item => {
            let obj = {
                id:item.id,
                inbound_id:this.inbound_id,
                line_id:item.line_id,
                product_id:item.product_id,
                pack_id:item.pack_id,
                batch:item.batch,
                expired_date:item.expired_date,
                uom_id:item.uom_id.id,
                qty:item.qty,
                base_uom_id:item.base_uom_id.id,
                open_qty:item.open_qty,
                recv_qty:item.recv_qty,
                base_qty:item.base_qty,
                status:item.status,
                };
            data_details.push(obj);
            });

            let data_send = {
            inbound_delivery : JSON.stringify(inbound_head),
            inbound_delivery_details :JSON.stringify(data_details),
            inbound_delivery_custom :JSON.stringify(inbound_detail_custom),
            };	
        
            this.$http.put('/inbound/inbounddelivery/'+this.$route.params.id+'/update',data_send)
            .then((resp) => {
                this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false
                
                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Inbound Succesfully'
                });
            })
            .catch((error) =>{
                this.isLoading = false
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error Update',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            });
        }
    },
    mounted(){
        this.gridApi = this.gridOptions.api;
        if(this.$route.params.id != undefined){
        this.isLoading = true;
        this.$http.post('unlock_all');
        this.$http.get('inbound/inbounddelivery/'+this.$route.params.id)
        .then((resp) => {
            let header = resp.data.inbound ;
            this.inbound_id = header.id ;
            this.inbound_reference = header.inbound_reference ;
            this.arrival_date = header.req_del_date ;
            this.supplier_address_1 = header.supplier.address_1 ;
            this.supplier_address_2 = header.supplier.address_2 ;
            this.inbound_status = header.status ;
            this.po_date = header.po_date ;
            this.supplier_id = header.supplier.id;
            this.client_id = header.client.id;
            this.order_type_id = header.order_type.id;
            this.warehouse_id = header.warehouse.id;
            this.remark = header.remark;

            this.client.data.push(header.client)
            this.order_type.data.push(header.order_type)
            this.warehouse.data.push(header.warehouse)
            this.supplier.data.push(header.supplier)

            // custom
            if(resp.data.inbounddetailcustom.length > 0){
                let custom = resp.data.inbounddetailcustom[0];
                this.custom_id = custom.id;
                this.aju_number = custom.aju_number || '';
                this.sppb_number = custom.sppb_number ;
                this.sppb_date = custom.sppb_date ;
                this.blorawb = custom.blorawb ;
                this.registration_number = custom.registration_number ;
                this.registration_date = custom.registration_date ;
                this.invoice_number = custom.invoice_number ;				
            }

            this.productOption = [];
            function getProductbyId(ax, id) {
                return ax.get('master/product/'+id);
            }	
            resp.data.inbounddetails.map(item => {
                if(this.productOption.findIndex(p => p.id === item.product_id) === -1) {
                    this.productOption.push(item.product);
                }

                let data_uom = [];
                item.product.uoms.map(uoms => {
                    uoms.uom.numerator = uoms.numerator
                    uoms.uom.denominator = uoms.denominator
                    data_uom.push(uoms.uom);
                });

                this.inboundItems.push({...item, uom_id:item.uom, base_uom_id:item.base_uom, status:'update', description: item.product.description_1, product_id:item.product.id, old_open_qty:item.open_qty, old_recv_qty:item.recv_qty, old_base_qty:item.base_qty, old_qty:item.qty,
                productOption:[item.product], uomOption:data_uom, baseUomOption:[item.base_uom], numerator:0, denominator: 0});

                this.detailLength += 1

                if(this.detailLength == resp.data.inbounddetails.length){
                    this.inboundItems.map(item => {
                        this.onChangeUom(item)
                    })
                }
            });
            
            this.isLoading = false
        })
        .catch((resp) =>{
          console.log(resp);
          // if(resp.response.status == 500){
          // } 
        });

        }else{
            this.$router.replace('/inbound-delivery');
        }
    },
	}
</script>

